import { msFunctions } from "../../formsviewer.xpath";
import { getProcessingInstruction, makePiDom } from "../utility/xmlHelpers";

const xslt = qd.xslt;
const $ = jQuery;

function upgradeEngine(template) {
    var settings = template.getUpgradeSettings();

    function getDocumentVersion(domRoot) {
        const pi = getProcessingInstruction(domRoot, "mso-infoPathSolution");
        const piDom = pi && makePiDom(pi);
        const version = piDom && piDom.getAttribute("solutionVersion");

        return version || null;
    }

    function compareVersions(v1, v2) {
        var v1Parts = v1.split("."),
            v2Parts = v2.split("."),
            maxParts = Math.max(v1Parts.length, v2Parts.length),
            v1Part,
            v2Part,
            i;

        for (i = 0; i < maxParts; i += 1) {
            v1Part = v1Parts[i];
            v2Part = v2Parts[i];

            if (!v1Part) {
                return -1;
            }
            if (!v2Part) {
                return 1;
            }
            if (+v1Part !== +v2Part) {
                return (+v1Part) - (+v2Part);
            }
        }

        return 0;
    }

    function shouldUpgrade(domRoot) {
        var min = settings.minVersion,
            max = settings.maxVersion,
            docVersion,
            fitsMinCriteria,
            fitsMaxCriteria;

        if (settings.type === "transform" && settings.transform) {
            docVersion = getDocumentVersion(domRoot);
            if (docVersion) {
                fitsMinCriteria = !min ||
                    (compareVersions(min, docVersion) <= 0);
                fitsMaxCriteria = !max ||
                    (compareVersions(docVersion, max) <= 0);

                return fitsMinCriteria && fitsMaxCriteria;
            }
        }

        return false;
    }

    // DomNode, String, XsltEngine -> DomNode
    function transformDom(dom, strUpgradeXsl) {
        var xslDom = $.parseXML(strUpgradeXsl);
        var processor = xslt.compile(xslDom);
        var result = processor.transform(dom, { functions: new msFunctions() });

        return result;
    }

    function performUpgradeAsync(dom) {
        return template.getTemplateFileAsync(settings.transform)
            .then(function (fileContents) { return transformDom(dom, fileContents); });
    }

    async function tryUpgradeAsync(document, api) {
        // Checks whether the provided DOM should be upgraded based on the template's upgrade settings
        // and returns a promise for the upgraded DOM if needed, or a promise for the provided DOM
        // if not

        return shouldUpgrade(document)
            ? performUpgradeAsync(document, api)
            : document;
    }

    return {
        tryUpgradeAsync,
    };
}

export default upgradeEngine;